import styled from 'styled-components';

export const CoachmarkContainer = styled.div`
  position: absolute;
  background-color: #222222;
  color: #ffffff;
  padding: 15px;
  border-radius: 5px;
  z-index: 12;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity 0.3s ease;
  width: ${props => props.width}px;
  &:after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 8px;
    border-style: solid;
    border-color: transparent transparent #222222 transparent;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 16px;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
`;

export const TargetElement = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
  background-color: #ffffff;

  .addCompareBtns {
    position: relative;
    z-index: 12;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 11;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
`;

export const ButtonWrap = styled.div`
  text-align: right;
  .coachMarkBtn {
    width: 120px;
    padding: 5px 0;
  }
`;
